import React from "react";
import { DocPage } from "../components/doc-page.tsx";

export function Terms() {
  return (
    <DocPage title="Terms of Service">
      <p>
        The Turnstile Terms of Service at{" "}
        <a href="https://turnstiletos.com/1.0.3">https://turnstiletos.com/1.0.3</a>{" "}
        govern use of this website. To use this website, you must agree to those
        terms.
      </p>
      <p>The website is https://authed.co</p>
      <p>The operator is Long Division, LLC.</p>
      <p>The governing law is Michigan.</p>
      <p>The forum for disputes is Detroit, Michigan.</p>
      <p>The operator's contact information is solve@longdi.vision</p>
      <p>These terms were last updated on May 5, 2026.</p>
    </DocPage>
  );
}
